module.exports = __webpack_public_path__ + "img/Church-of-St-George-Sofia.2ef481cd.jpg";